import { Interaction } from './interaction';

import DrawInteraction from 'ol/interaction/Draw';
import { createBox } from 'ol/interaction/Draw';

import { unByKey } from 'ol/Observable';

class Draw extends Interaction {

	constructor(interaction) {
		super(interaction);
	}
	
	addDrawEventHandler(handler) {
		const key = this.interaction.on('drawend', ({feature}) => handler(feature));
		return () => unByKey(key);	
	} 
	
	getExtent() {
		const geom = this.geometry.getGeometry();
		return geom.getExtent();
	}
}

const draw = (type, style, maxPoints, geometryFunction) => {       
    const options = {
        style: style,
        type: type,
        geometryFunction: geometryFunction       
    };
        
    if( maxPoints > 0 ) {
        options.maxPoints = maxPoints;
    }
               
    const draw = new DrawInteraction(options);	   	
   	return new Draw( draw );  
}

const drawRegularPolygon = (style) => {       
    return draw('Circle', style, undefined, createBox());
}

export {
	draw, drawRegularPolygon, Draw
}
